import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import style from "./styles.module.scss";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { LoadingField, FormSelect } from "../../Asset/Controls";

const initialFields = {
  AccountGroupId: undefined,
  AccountGroupValue: undefined,
  AccountGroupName: undefined,
};

const ModalGroup = ({ open, toggle, services, group, onConfirm }) => {
  const [groups, setGroups] = useState(false);
  const [values, setValues] = useState([]);

  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (group) {
      setFields(group);
    } else {
      setFields(initialFields);
    }
  }, [group]);

  useEffect(() => {
    services.getAccountGroups({}, (response) => {
      if (response && response.items) {
        setGroups(response.items);

        if (!group) {
          if (response.items.length > 0) {
            setFields({
              ...fields,
              AccountGroupId: response.items[0].AccountGroupId,
              AccountGroupName: response.items[0].AccountGroupName,
            });
          }
        }
      }
    });
  }, []);

  useEffect(() => {
    if (fields.AccountGroupId) {
      for (var i = 0; i < groups.length; i++) {
        if (Number(groups[i].AccountGroupId) == Number(fields.AccountGroupId)) {
          setValues(groups[i].Values);
        }
      }
    }
  }, [fields.AccountGroupId]);

  const onChange = (name, value) => {
    let groupName = "";
    if (name === "AccountGroupId") {
      for (var i = 0; i < groups.length; i++) {
        if (Number(groups[i].AccountGroupId) == Number(value)) {
          groupName = groups[i].AccountGroupName;
        }
      }
      setFields({ ...fields, [name]: value, AccountGroupName: groupName });
    } else {
      setFields({ ...fields, [name]: value });
    }
    setErrors({ ...errors, [name]: undefined });
  };

  return (
    <Modal isOpen={open} toggle={toggle} className={style.modal}>
      <ModalHeader toggle={toggle}>Add Account group</ModalHeader>
      <ModalBody>
        {groups ? (
          <FormSelect
            name="AccountGroupId"
            label="Account group"
            selectItems={groups}
            getSelectItemId={(i) => i.AccountGroupId}
            getSelectItemName={(i) => i.AccountGroupName}
            value={fields.AccountGroupId}
            onChange={onChange}
          />
        ) : (
          <LoadingField label="Account group" />
        )}
        {values ? (
          <FormSelect
            name="AccountGroupValue"
            label="Account group value"
            selectItems={values}
            getSelectItemId={(i) => i.AccountGroupValue}
            getSelectItemName={(i) => i.AccountGroupValue}
            value={fields.AccountGroupValue}
            onChange={onChange}
          />
        ) : (
          <LoadingField label="Account group value" />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary pl-3 pr-3"
          loading={loading}
          disabled={fields.AccountGroupValue === undefined || fields.AccountGroupId === undefined}
          onClick={() => onConfirm(fields)}
          data-style={SLIDE_LEFT}
        >
          <i className="fa fa-floppy-o mr-1" aria-hidden="true"></i>
          Save
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

export default ModalGroup;
